import React, { useState, useEffect } from "react";
import { SelectBox, Popup } from "devextreme-react";
import StartupApi from "Api/Startup";
import Listing from "components/common/Listing";
import moment from "moment";
import Uploader from "components/common/Uploader";
import Input from "components/common/Input";
import Form from "components/common/Form";
import Utils from "Utils";
import Copy from "components/common/Copy";

export default function DocumentBox({ startupId }) {
  const FORM_VALUES = {
    type: null,
    file: null,
  };

  const [showPopup, setShowPopup] = useState(false);
  const [showFormPopup, setShowFormPopup] = useState(false);
  const [documents, setDocuments] = useState([]);

  const getStartupDocuments = async (startupId) => {
    const documents = await StartupApi.getStartupDocuments(startupId);
    if (documents.status === 200) {
      setDocuments(documents.data);
    }
  };

  useEffect(() => {
    if (showPopup) {
      getStartupDocuments(startupId);
    }
  }, [showPopup]);

  const uploadDocuments = async (data) => {
    data.file = data.file[0];
    data.startup = startupId;
    const response = await StartupApi.uploadStartupDocuments(data);
    if (response.status === 201) {
      Utils.notify("Document uploaded successfully!", "success", 4000);
      setDocuments([...documents, response.data]);
      setShowFormPopup(false);
    }
  };

  return (
    <div className="document-box">
      <button className="btn btn-info" onClick={() => setShowPopup(true)}>
        Document Box
      </button>
      <Popup
        visible={showPopup}
        onHiding={() => setShowPopup(false)}
        closeOnOutsideClick={false}
        title="Document Box"
        // height="240px"
        // width="350px"
      >
        <i
          className="material-icons pointer"
          onClick={() => setShowFormPopup(true)}
        >
          add_box
        </i>
        <p>
          <b>{documents.length}</b> Documents uploaded
        </p>
        <Listing
          headers={["Document Type", "Created At", "Copy Download Link"]}
          headerLayout={"1fr repeat(2, 20%)"}
          dataLayout={"1fr repeat(2, 20%)"}
          dataSource={documents}
          dataKeys={[
            "type",
            {
              name: "created",
              render: (data) => {
                return <div>{moment(data.created).format("LL")}</div>;
              },
            },
            {
              name: "file",
              render: (data) => {
                return (
                  <div>
                    <Copy content={""} toBeCopied={data.file} />
                  </div>
                );
              },
            },
          ]}
          uniqueKey={"id"}
        />
        <Popup
          visible={showFormPopup}
          onHiding={() => setShowFormPopup(false)}
          closeOnOutsideClick={false}
          title="Upload Document"
          height="300px"
          width="400px"
        >
          <Form
            onSubmit={uploadDocuments}
            defaultValues={FORM_VALUES}
            className="flex flex-column gap-10"
          >
            <Input
              name={"type"}
              placeholder={"Document Name"}
              validations={{ required: "Type is required" }}
            />
            <Uploader
              name={"file"}
              btnText={"Pick a document"}
              validations={{ required: "File is required" }}
            />
            <button className="btn btn-success" htmlType="submit">
              Upload
            </button>
          </Form>
        </Popup>
      </Popup>
    </div>
  );
}
